/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCorporationsCorporationIdDivisionsWalletWallet } from './GetCorporationsCorporationIdDivisionsWalletWallet';
import {
    GetCorporationsCorporationIdDivisionsWalletWalletFromJSON,
    GetCorporationsCorporationIdDivisionsWalletWalletFromJSONTyped,
    GetCorporationsCorporationIdDivisionsWalletWalletToJSON,
    GetCorporationsCorporationIdDivisionsWalletWalletToJSONTyped,
} from './GetCorporationsCorporationIdDivisionsWalletWallet';
import type { GetCorporationsCorporationIdDivisionsHangarHangar } from './GetCorporationsCorporationIdDivisionsHangarHangar';
import {
    GetCorporationsCorporationIdDivisionsHangarHangarFromJSON,
    GetCorporationsCorporationIdDivisionsHangarHangarFromJSONTyped,
    GetCorporationsCorporationIdDivisionsHangarHangarToJSON,
    GetCorporationsCorporationIdDivisionsHangarHangarToJSONTyped,
} from './GetCorporationsCorporationIdDivisionsHangarHangar';

/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdDivisionsOk
 */
export interface GetCorporationsCorporationIdDivisionsOk {
    /**
     * hangar array
     * @type {Array<GetCorporationsCorporationIdDivisionsHangarHangar>}
     * @memberof GetCorporationsCorporationIdDivisionsOk
     */
    hangar?: Array<GetCorporationsCorporationIdDivisionsHangarHangar>;
    /**
     * wallet array
     * @type {Array<GetCorporationsCorporationIdDivisionsWalletWallet>}
     * @memberof GetCorporationsCorporationIdDivisionsOk
     */
    wallet?: Array<GetCorporationsCorporationIdDivisionsWalletWallet>;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdDivisionsOk interface.
 */
export function instanceOfGetCorporationsCorporationIdDivisionsOk(value: object): value is GetCorporationsCorporationIdDivisionsOk {
    return true;
}

export function GetCorporationsCorporationIdDivisionsOkFromJSON(json: any): GetCorporationsCorporationIdDivisionsOk {
    return GetCorporationsCorporationIdDivisionsOkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdDivisionsOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdDivisionsOk {
    if (json == null) {
        return json;
    }
    return {
        
        'hangar': json['hangar'] == null ? undefined : ((json['hangar'] as Array<any>).map(GetCorporationsCorporationIdDivisionsHangarHangarFromJSON)),
        'wallet': json['wallet'] == null ? undefined : ((json['wallet'] as Array<any>).map(GetCorporationsCorporationIdDivisionsWalletWalletFromJSON)),
    };
}

export function GetCorporationsCorporationIdDivisionsOkToJSON(json: any): GetCorporationsCorporationIdDivisionsOk {
    return GetCorporationsCorporationIdDivisionsOkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdDivisionsOkToJSONTyped(value?: GetCorporationsCorporationIdDivisionsOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hangar': value['hangar'] == null ? undefined : ((value['hangar'] as Array<any>).map(GetCorporationsCorporationIdDivisionsHangarHangarToJSON)),
        'wallet': value['wallet'] == null ? undefined : ((value['wallet'] as Array<any>).map(GetCorporationsCorporationIdDivisionsWalletWalletToJSON)),
    };
}

